@if (title) {
  <div class="modal-header" id="pop-title">
    <div class="modal-toolbar">
      <div class="modal-title">{{ title }}</div>
    </div>
  </div>
}

<div id="pop-select-content" class="app-content">
  <div class="container">

    @if (search) {
      <div class="search-options">
        <div class="search-bar">
          <app-display-icon [icon]="icons.magnify"></app-display-icon>
          <input
            (input)="searchOptions($event)"
            placeholder="Search"
            type="search">
        </div>
      </div>
    }

    <div class="variable-list-div">
      <!-- Select all won't work on the SINGLE SELECT option -->
      @if (selectAll) {
        <div [class]="'select-option select-all' + (allSelected ? ' selected' : '')">
          <button (click)="toggleAll()" type="button">
            <app-display-icon [colour]="iconColourEnum.black" [icon]="icons.checkAll"></app-display-icon>
            Select All
          </button>
        </div>
      }

      <!-- --------------------------------------------- MULTI SELECT ---------------------------------------------- -->
      @if (multiple) {
        <div
          [class]="'options' + (!selectionClasses && !selectionStyles ? ' default-even-grey' : '')">
          @for (sKey of order; track $index) {
            <div
              (click)="selectSKey(sKey)"
              [ngClass]="classes[sKey] + (disabled.includes(sKey) ? ' disabled' : '')"
              [ngStyle]="selectionStyles?.[sKey] || {}"
              class="item-for-selection">
              <input
                type="checkbox"
                [(ngModel)]="checks[sKey]"
                [disabled]="disabled && disabled.includes(sKey)"
                (click)="$event.stopPropagation()"
                (ngModelChange)="syncAllSelected()">
              <span>{{ selection[sKey] }}</span>
              @if (invalidKeys.includes(sKey)) {
                <app-display-icon
                  class="invalid-email-warning"
                  [colour]="iconColourEnum.yellow"
                  [icon]="icons.alertRhombusOutline"
                  [tooltip]="selectionToPlaceIcons[sKey]
                    ? 'This email is invalid. Please update the recipient on IQ in order to fix or add one below.'
                    : 'This email is invalid. Please delete the recipient or replace it with a valid address.'">
                </app-display-icon>
              }
              @if (isAdditionalIconVisible && selectionToPlaceIcons[sKey]) {
                <app-display-icon
                  [icon]="additionalIcon">
                </app-display-icon>
              }
              @if (isDeleteVisible && !selectionToPlaceIcons[sKey]) {
                <app-display-icon
                  (click)="onDeleteClick(sKey)"
                  [colour]="iconColourEnum.red"
                  [icon]="icons.deleteOutline">
                </app-display-icon>
              }
            </div>
          }
        </div>
      } @else {
        <div [class]="'options single' + (!selectionClasses && !selectionStyles ? ' default-even-grey' : '')">
          @for (sKey of order; track $index) {
            <div
              (click)="selectSKey(sKey)"
              [ngClass]="classes[sKey] + (disabled.includes(sKey) ? ' disabled' : '')"
              [ngStyle]="selectionStyles?.[sKey] || {}">
              <app-display-icon
                [icon]="checked === sKey ? icons.radioBoxMarked : icons.radioBoxBlank">
              </app-display-icon>
              <span>{{ selection[sKey] }}</span>
            </div>
          }
        </div>
      }

      <!-- --------------------------------------------- SINGLE SELECT --------------------------------------------- -->
    </div>

    @if (selectModButtons) {
      <div [class]="'select-mod-buttons' + (selectModButtons.length === 1 ? ' single' : '')">
        @for (butt of selectModButtons; track $index) {
          <button
            (click)="selectionModHandle(butt.handler)"
            [class]="butt.cssClass"
            type="button">
            {{ butt.text }}
          </button>
        }
      </div>
    }

    <div class="main-buttons">
      <span class="custom">
        @if (additionalMainButton) {
          <button
            (click)="additionalHandle(additionalMainButton.handler)"
            [class]="additionalMainButton.cssClass"
            type="button">
            {{ additionalMainButton.text }}
          </button>
        }
      </span>
      <span class="complete">
        <button (click)="onCancel()" class="cancel-button" type="button">
          {{ cancelText }}
        </button>
        <button (click)="onSubmit()" class="ok-button" type="button">
          {{ okText }}
        </button>
      </span>
    </div>
  </div>
</div>
